export default "__VITE_ASSET__ebfc8453__"